import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';

import { colors } from '../../styles';
import { UnderdogLeft, BtnAnimationSheen } from '../../helpers/UIElements';

const styles = css`
  padding-top: 90px;
  padding-bottom: 100px;
  @media(min-width: 992px) {
    padding-top: 100px;
    padding-bottom: 150px;
  }
  .Testimonials_list {
    list-style: none;
    padding: 0;
    margin-bottom: 64px;
    @media(min-width: 992px){margin-bottom:43px;}
    li {
      padding-bottom: 50px;
      padding-top: 44px;
      margin-bottom: 15px;
      margin-bottom: 0;
      display: flex;
      flex-direction: column;
      &:first-child{
        padding-top: 0px;
      }
      @media(min-width: 992px) {
        flex-direction: row;
        background-size: 0;
        display: flex;
        padding-top: 44px;
      }
      .Testimonials_content {
        font-weight: 300;
        font-size: 18px;
        color: ${colors.text};
        letter-spacing: 0;
        line-height: 36px;
        @media(min-width: 992px) {
          font-weight: 400;
          font-size: 21px;
          line-height: 40px;
        }
      }
      .Testimonials_contact {
        font-size: 12px;
        color: #000000;
        letter-spacing: 0;
        line-height: 35px;
        text-transform: uppercase;
        margin-top: 20px;
        @media(min-width: 992px) {
          font-size: 14px;
          letter-spacing: 3.07px;
          line-height: 20px;
        }
      }
      .Testimonials_name{
        font-weight: 700;
      }
    }
  }
  .TestimonialsMore_btnWrapper {
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
    @media(min-width: 992px) {
      margin: 50px 0;
      height: 100px;
    }
    .TestimonialsMore_text {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      line-height: 30px;
      @media(min-width: 992px) {
        font-size: 16px;
        line-height: 35px;
      }
    }
    .TestimonialsMore_btn {
      background-color: #D80017;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 200px;
      padding: 0 50px;
      border-radius: 5px;
      font-weight: 700;
      font-size: 12px;
      color: #FFFFFF;
      letter-spacing: 1.71px;
      text-transform: uppercase;
      cursor: pointer;
      @media(min-width: 992px) {
        padding: 0 60px;
        height: 60px;
        box-shadow: 0 15px 20px 0 rgba(0,0,0,0.20);
        font-weight: 700;
        font-size: 14px;
        letter-spacing: 2px;
        transition: all .3s ease-out;
      }
      &:hover {
        @media(min-width: 992px) {
          background-color: ${colors.color2};
        }
      }
      &:focus {
        outline: none;
      }
    }
  }
  .Testimonials_showmore {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 14px;
    color: ${colors.color1};
    cursor: pointer;
    &:focus {
      outline: none;
    }
  }
  .Testimonials_quote{
    height: 36px;
    margin-bottom: 19px;
    opacity: 0.1;
    @media(min-width: 992px){
      height: 58px;
      width: 75px;
      margin-bottom: 0px;
      margin-right: 62px;

    }
  }
  .Testimonials_imageWrapper{
    order: 1;
    margin-bottom: 12px;
    @media(min-width: 992px){
      order:3;
      margin-bottom: 0px;
    }
    @media(min-width: 0\0) {
      width: 539px;
    }
  }
  .Testimonials_image{
    width: 100%;
  }
  .Testimonials_wrap{
    width:100%;
    order: 2;
    @media(min-width: 992px){
      margin-right: 88px;
    }
    &::after, &::before {
      background-color: ${colors.color1};
    }
  }

  .Underdog_left{
    &:after{
      background-color: ${colors.color4};
      width: 150px;
    }
  }
  .PlansMore_btnWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 0;
    @media(min-width: 992px) {
      padding: 45px 0;
    }
  }
  .PlansMore_btn {
    height: 45px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 0.12px;
    background-color: ${colors.color1};
    cursor: pointer;
    @media(min-width: 992px) {
      height: 55px;
      padding: 0 35px;
      font-size: 17px;
      letter-spacing: 0;
    }
    &:focus {
      outline: none;
    }
  }
`;
const Increment = 4;

class Testimonials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: Increment,
      wordsLimit: 200,
    };
  }
  showMorePlans = () => {
    this.setState({ limit: this.state.limit + Increment });
  }
  readMoreHandler = () => {
    const wordsLimit = this.state.wordsLimit;

    if (wordsLimit === Infinity) {
      this.setState({ wordsLimit: 200 });
    } else {
      this.setState({ wordsLimit: Infinity });
    }
  }
  render() {
    const { limit } = this.state;
    const { content } = this.props;

    // const testimonialsLeft = content.length - limit > limit ? limit : content.length - limit;
    return (
      <div className={styles}>
        <div className="container">
          <ul className="Testimonials_list">
            {
              content.slice(0, limit).map(item => (
                <li key={item._id}>
                  <div className="d-none d-lg-block">
                    <img className="Testimonials_quote" src="images/icons/icon-quote-black.svg" alt="quotes" />
                  </div>
                  <UnderdogLeft className="Testimonials_wrap">
                    <div className="Testimonials_content">{get(item, 'content')}</div>
                    <div className="Testimonials_contact"><span className="Testimonials_name">{get(item, 'name')}</span> {item.title ? `| ${item.title}` : ''}</div>
                  </UnderdogLeft>
                  {
                    get(item, 'image') &&
                    <div className="Testimonials_imageWrapper">
                      <Image className="Testimonials_image" src={item.image.contentUrl} alt="quotes" width={600} height={500} />
                    </div>
                  }
                </li>
              ))
            }
          </ul>
          {
            limit < content.length &&
              <div className="PlansMore_btnWrapper">
                <BtnAnimationSheen
                  className="PlansMore_btn mt-3"
                  onClick={this.showMorePlans}
                  role="button"
                  tabIndex={0}
                >
                    Load More
                </BtnAnimationSheen>
              </div>
          }
        </div>
      </div>
    );
  }
}

Testimonials.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Testimonials;



// WEBPACK FOOTER //
// ./src/pages/Testimonials/Testimonials.js